class GiftOptionsPanel extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('.gift-options__trigger');
    this.panel = this.querySelector('.gift-options__panel');

    if (!this.trigger || !this.panel) return;

    this.trigger.addEventListener('click', () => this.togglePanel());

    this.querySelectorAll('[data-gift-item]').forEach(btn => {
      btn.dataset.originalText = btn.textContent.trim();
      btn.addEventListener('click', () => {
        const pressed = btn.getAttribute('aria-pressed') === 'true';
        const nowPressed = !pressed;
        btn.setAttribute('aria-pressed', String(nowPressed));
        btn.textContent = nowPressed ? 'ADDED' : btn.dataset.originalText;
        this.syncInputs();
      });
    });

    this.syncInputs();
  }

  togglePanel() {
    const expanded = this.trigger.getAttribute('aria-expanded') === 'true';
    this.trigger.setAttribute('aria-expanded', String(!expanded));
    this.panel.hidden = expanded;
  }

  syncInputs() {
    let index = 1;
    this.querySelectorAll('[data-gift-item]').forEach(btn => {
      const slot = btn.dataset.giftSlot;
      const active = btn.getAttribute('aria-pressed') === 'true';

      this.querySelectorAll(`[data-gift-input][data-gift-slot="${slot}"]`).forEach(input => {
        if (active) {
          input.name = `items[${index}][${input.dataset.giftField}]`;
        } else {
          input.removeAttribute('name');
        }
      });

      const noteInput = this.querySelector(`[data-gift-note][data-gift-slot="${slot}"]`);
      if (noteInput) {
        if (active) {
          noteInput.hidden = false;
          noteInput.name = `items[${index}][properties][Gift Wrap Note]`;
        } else {
          noteInput.hidden = true;
          noteInput.removeAttribute('name');
        }
      }

      if (active) index++;
    });
  }
}

if (!customElements.get('gift-options-panel')) {
  customElements.define('gift-options-panel', GiftOptionsPanel);
}

if (!customElements.get('product-gift-wrap')) {
  customElements.define('product-gift-wrap', class extends HTMLElement {});
}
